import IconRiskTier1 from "@/components/icons/risk-tiers/IconRiskTier1.vue";
import IconRiskTier2 from "@/components/icons/risk-tiers/IconRiskTier2.vue";
import IconRiskTier3 from "@/components/icons/risk-tiers/IconRiskTier3.vue";
import IconRiskTier4 from "@/components/icons/risk-tiers/IconRiskTier4.vue";
import IconRiskTier5 from "@/components/icons/risk-tiers/IconRiskTier5.vue";
import IconRiskTier6 from "@/components/icons/risk-tiers/IconRiskTier6.vue";

import type { Component } from "vue";

export const RISK_TIER_ICONS: Record<string, Component> = {
  1: IconRiskTier1,
  2: IconRiskTier2,
  3: IconRiskTier3,
  4: IconRiskTier4,
  5: IconRiskTier5,
  6: IconRiskTier6,
};
